export default {
	about: '',
	mission: '',
	vision: ''
}